import { startCase } from 'lodash';

import { Certificate } from '@legacy-types';

import { Tooltip } from '@shared/ui/components/Tooltip';

type CertificateStatusBadgeProps = {
  certificate: Certificate;
};

export function CertificateStatusBadge({ certificate }: CertificateStatusBadgeProps) {
  const statusColors = {
    pending: 'warning',
    approved: 'success',
    rejected: 'danger',
    expired: 'metal',
  };

  return (
    <Tooltip
      content={
        certificate.publicComment && (
          <p>
            <strong className="font-bold">Note:</strong> {certificate.publicComment}
          </p>
        )
      }
    >
      <span className={`m-badge m-badge--${statusColors[certificate.status]} m-badge--wide`}>
        {startCase(certificate.status)}
        {certificate.publicComment && '*'}
      </span>
    </Tooltip>
  );
}
